import { SelectModel } from '@shared/form/select.model';

export const LANGUAGES = Object.freeze({
  'EN': 'English',
  'FR': 'French',
  'DE': 'German',
  'ES': 'Spanish',
  'AO': 'AsianOdds | English',
  'AO-FR': 'AsianOdds | French',
  'AO-ES': 'AsianOdds | Spanish',
});

export const SIZES = Object.freeze({
  '300x300': '300x300',
  '300x250': '300x250',
  '250x250': '250x250',
  '468x60': '468x60',
  '728x90': '728x90',
});

export const PROTOCOLS = Object.freeze({
  http: 'http',
  https: 'https',
});

class BannerForm {
  constructor() {
    this._website = null;
    this._protocol =  PROTOCOLS.http;
    this._type = 'promotion';
    this._language = '';
    this._size = '';
    this._campaignName = null;
    this._trackingCode = null;

    // Selects
    this._protocolSelect = new SelectModel(PROTOCOLS);
    this._languagesSelect = new SelectModel(Object.assign({'': 'Please Select'}, LANGUAGES));
    this._sizesSelect = new SelectModel(Object.assign({'': 'Please Select'}, SIZES));

    this._errors = {};

    this.props = { readOnly: false };
  }

  set website(website) {
    this._website = website;
  }

  get website() {
    return this._website;
  }

  set protocol(protocol) {
    this._protocol = protocol;
  }

  get protocol() {
    return this._protocol;
  }

  set type(type) {
    this._type = type;
  }

  get type() {
    return this._type;  
  }

  set language(language) {
    return this._language = language;
  }

  get language() {
    return this._language;
  }

  set size(size) {
    this._size = size;
  }

  get size() {
    return this._size;
  }

  set campaignName(campaignName) {
    this._campaignName = campaignName;
  }

  get campaignName() {
    return this._campaignName;
  }

  set trackingCode(trackingCode) {
    this._trackingCode = trackingCode;
  }

  get trackingCode() {
    return this._trackingCode;
  }

  set errors(errors) {
    this._errors = errors.children;
  }

  get errors() {
    return this._errors;
  }

  toPayload() {
    return {
      memberBanner: {
        website: this.formatWebsite(this.protocol, this.website),
        type: this.type,
        language: this.toLanguageShortCode(this.language),
        size: this.size,
        campaignName: this.campaignName,
        trackingCode: this.trackingCode
      }
    }
  }

  formatWebsite(protocol, website) {
    let protocolWebsite = '';

    if (website !== null && website !== '') {
        protocolWebsite = protocol + '://' + website;
    }

    return protocolWebsite;
  }


  toLanguageShortCode(language) {
    for(let prop in LANGUAGES){
      if (prop === language) {
        return prop;
      }
    }

    return '';
  }

  clear() {
    this._website = null;
    this._type = 'promotion';
    this._protocol = PROTOCOLS.http;
    this._language = null;
    this._size = null;
    this._campaignName = null;
    this._trackingCode = null;

    this._errors = {};

    this.props = { readOnly: false };
  }

  clearErrors() {
    this._errors = {};
  }

  get canPreviewBanner() {
    return this.language !== null && this.size !== null;
  }

  get protocolSelect() {
    return this._protocolSelect;
  }

  get languagesSelect() {
    return this._languagesSelect;
  }

  get sizesSelect() {
    return this._sizesSelect;
  }
}

export default BannerForm;



// WEBPACK FOOTER //
// ./client/app/pages/marketing/model/form.model.js